<template>
  <router-view />
</template>

<script>
export default {
  name: "app-rule"
};
</script>

<style lang="scss" scoped></style>
